import { useEffect } from 'react';

import { trackStandaloneChange } from '../helpers';
import { CustomerIOEvents } from '@/helpers/customerio';
import { useCustomerIO } from '@/hooks/3dParty/customerIO';

const pwaOpenedEventsFired = () =>
  localStorage.getItem('pwaOpenedEventsFired') === 'true';

export const usePwaOpened = () => {
  const { trackCustomEvent } = useCustomerIO();
  useEffect(() => {
    const unsubscribe = trackStandaloneChange((isStandalone) => {
      if (!pwaOpenedEventsFired() && isStandalone) {
        trackCustomEvent(CustomerIOEvents.PWA_INSTALLED);
        localStorage.setItem('pwaOpenedEventsFired', 'true');
      }
    });
    return unsubscribe;
  }, [trackCustomEvent]);
};
